import { Shield } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useAdminSession } from '@hooks/useAdminSession'

export default function AdminCapabilityRoute({ capability, children }) {
  const { hasCapability } = useAdminSession()

  if (hasCapability(capability)) {
    return children
  }

  return (
    <section className="border border-amber-200 bg-amber-50 p-5 dark:border-amber-900 dark:bg-amber-900/20">
      <div className="flex items-start gap-3">
        <Shield
          className="mt-0.5 h-5 w-5 flex-none text-amber-700 dark:text-amber-300"
          aria-hidden="true"
        />
        <div>
          <h2 className="text-base font-semibold text-amber-950 dark:text-amber-100">
            Permission required
          </h2>
          <p className="mt-1 text-sm text-amber-800 dark:text-amber-200">
            Your administrator session does not grant access to this
            destination.
          </p>
          <Link
            to="/admin"
            className="mt-4 inline-flex text-sm font-medium text-amber-900 hover:underline dark:text-amber-100"
          >
            Return to admin Home
          </Link>
        </div>
      </div>
    </section>
  )
}
